import { useSelector } from "react-redux";
import { isLoading } from "../../../common/helper/commonHelper";
import { Account } from "../../../common/types/auth";
import IModal from "../../../components/IModal";
import { useAppDispatch } from "../../../store";
import { deactivateUser, selectUser } from "./userSlice";

export default function DeactivateUserModal({
  onClose,
  isOpen,
  data,
}: {
  onClose: () => void;
  isOpen: boolean;
  data: Account | null;
}) {
  const dispatch = useAppDispatch();
  const { deactivatedAccount } = useSelector(selectUser);

  async function confirmDeactivation() {
    if (data) {
      await dispatch(deactivateUser(data.id));
    }
    onClose();
  }

  return (
    <IModal
      isOpen={isOpen}
      onClose={onClose}
      size="2xl"
      header={{ title: "Confirm Deactivation" }}
      deleteButton={{
        label: "Deactivate",
        props: {
          onClick: confirmDeactivation,
          isLoading: isLoading(deactivatedAccount.loading),
        },
      }}
      secondaryButton={{
        label: "Cancel",
        props: {
          onClick: onClose,
        },
      }}
    >
      Are you sure you want to deactivate this account?
    </IModal>
  );
}
